module.exports = __webpack_public_path__ + "static/media/Banner4.185a6d7c.jpeg";